import Fuse from 'fuse.js';

/**
 * App-wide Fuse.js defaults. threshold 0.35 = tolerate roughly one typo in a
 * short word without matching everything; ignoreLocation so matches count
 * anywhere in the string, not just near the start.
 */
const DEFAULT_OPTIONS = {
  threshold: 0.35,
  ignoreLocation: true,
  minMatchCharLength: 2,
};

/**
 * Build a Fuse instance with app defaults.
 * @param {object[]|string[]} items
 * @param {Array<{name: string, weight: number}>} [keys] — omit for plain string arrays
 * @param {object} [options] — per-caller overrides
 */
export function createFuzzy(items, keys, options = {}) {
  return new Fuse(items, {
    ...DEFAULT_OPTIONS,
    ...(keys ? { keys } : {}),
    ...options,
  });
}

/**
 * Fuzzy-filter a plain string array. Empty query returns the list unchanged;
 * 1-char queries use substring matching because Fuse's minMatchCharLength
 * would return nothing.
 */
export function fuzzyFilterStrings(list, query) {
  const q = (query || '').trim();
  if (!q) return list;
  if (q.length < 2) {
    const lower = q.toLowerCase();
    return list.filter((s) => s.toLowerCase().includes(lower));
  }
  return createFuzzy(list).search(q).map((r) => r.item);
}
